import { i18n } from 'arm-common';
import update from 'immutability-helper';
import app_actions from '../../app/app_actions';
import BaseActions from '../../app/_base_actions';
import Rest from '../../webapi/Rest';
import DataSourceActions from '../dataSource/DataSourceActions';
import AppActions from '../../app/app_actions';
import { reject } from 'lodash';


const EnumDocumentiActions = Object.freeze({
    DOCUMENTI_LIST: 'DOCUMENTI_LIST',
    DOCUMENTO_VERSIONE: 'DOCUMENTO_VERSIONE',
    ID_ULTIMA_VERSIONE: 'ID_ULTIMA_VERSIONE',
    ID_DOCUMENTO_ORIGINE: 'ID_DOCUMENTO_ORIGINE',
    HANDLE_CHANGE_DOC: 'HANDLE_CHANGE_DOC',
    DOCUMENTO_UPDATE: 'DOCUMENTO_UPDATE',
    PUBLISH_DOCUMENT: 'PUBLISH_DOCUMENT',
    REMOVE_FILE: 'REMOVE_FILE',
    LOAD_DOCUMENTO: 'LOAD_DOCUMENTO',
    DOCUMENTI_UPDATE: 'DOCUMENTI_UPDATE',
    DATA_SOURCE_LIST: 'DATA_SOURCE_LIST',
    HANDLE_CHANGE_DS: 'HANDLE_CHANGE_DS',
    HANDLE_CHANGE_PARAM: 'HANDLE_CHANGE_PARAM',
    GET_DS: 'GET_DS',
    TOGGLE_MODIFICA: 'TOGGLE_MODIFICA',
    SET_IS_IN_EDIT_MODE: 'SET_IS_IN_EDIT_MODE',
    TOGGLE_MOSTRA_POPUP_CONFERMA_NUOVA_VERSIONE: 'TOGGLE_MOSTRA_POPUP_CONFERMA_NUOVA_VERSIONE',
    IS_ALREADY_EXISTING_DOC: 'IS_ALREADY_EXISTING_DOC',
    TEST: 'TEST',
    SHOW_CONFIRM_PUBLIC_DOC: 'SHOW_CONFIRM_PUBLIC_DOC'
});

module.exports.DocumentiActions = EnumDocumentiActions;


class DocumentiActions extends BaseActions {
    constructor() {
        super();
        this.moduleName = "[DocumentiActions] ";
    }

    get Actions() {
        return EnumDocumentiActions;
    }

    setConfirmPublicDoc(val) {
        return function (dispatch) {
            dispatch({ type: EnumDocumentiActions.SHOW_CONFIRM_PUBLIC_DOC, showConfirmPublicDoc: val });
        }
    }
    changeSelectedTab(idTab) {
        return function (dispatch) {

            let documenti = {
                tabSelected: {
                    $set: idTab
                }
            }

            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: documenti });
            return Promise.resolve();
        }
    }

    changeDSSelectedTab(idTab) {
        return function (dispatch) {

            let documenti = {
                dataSourceTabSel: {
                    $set: idTab
                }
            }

            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: documenti });
            return Promise.resolve();
        }
    }

    getDocumenti() {
        return function (dispatch) {
            return Rest.post('admin/armCorePrint/listaDocumentiOrigine', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumDocumentiActions.DOCUMENTI_LIST, result: resolve });
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    getVersioniDocumento(idDocumento) {

        return function (dispatch) {
            return Rest.postForm('admin/armCorePrint/listaVersioniDocumento', { idDocumento: idDocumento }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumDocumentiActions.DOCUMENTO_VERSIONE, result: resolve });
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    updateIdUltimaVersioneDocumento(idUltimaVersioneDoc) {
        return function (dispatch) {
            console.log('Id ultima versione' + idUltimaVersioneDoc);
            dispatch({ type: EnumDocumentiActions.ID_ULTIMA_VERSIONE, result: idUltimaVersioneDoc });
            return Promise.resolve();
        }
    }

    handleChangeDoc(id, value, tipo) {
        return function (dispatch, getState) {
            let nuovoDoc = getState().documentiReducer.nuovoDoc;
            if (tipo && tipo === "date") {
                let dt = new Date(value);

                value = dt.getTime();
            }
            if (id === "content" || id === "template") {
                // value returns a pojo
                let fileIdVal;
                if (value) {
                    fileIdVal = value.fileId;
                }
                let fileId = id + "Id";
                nuovoDoc[id] = [];
                nuovoDoc = update(nuovoDoc, {
                    [id]: { $set: value },
                    [fileId]: { $set: fileIdVal },
                })
            }
            else {
                nuovoDoc = update(nuovoDoc, {
                    [id]: { $set: value }
                })
            }
            dispatch({ type: EnumDocumentiActions.HANDLE_CHANGE_DOC, result: nuovoDoc })
        }
    }

    handleChangeDs(id, value) {
        return function (dispatch, getState) {
            let dataSource = getState().documentiReducer.dataSource;
            if (id === "content" || id === "template") {
                dataSource[id] = [];
                dataSource = update(dataSource, {
                    [id]: { $push: [value] }
                })
            } else {
                dataSource = update(dataSource, {
                    [id]: { $set: value }
                })
            }
            dispatch({ type: EnumDocumentiActions.HANDLE_CHANGE_DS, result: dataSource })
        }
    }

    removeFile(fileIdx, name) {
        return function (dispatch, getState) {

            let nuovoDoc = getState().documentiReducer.nuovoDoc;
            nuovoDoc = update(nuovoDoc, {
                // [name]: { $set: [] }
                [name]: { $set: {} }
            })

            // tolgo il documento anche dalla entity
            let parameter;
            if (name === "template") {
                parameter = "idPrintTemplate"
            } else {
                name = "idPrintContent"
            }

            let updateDocument = {
                nuovoDoc: {
                    [parameter]: {
                        $set: null
                    },
                    [name]: {
                        $set: {}
                    }
                },
            }

            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
        }
    }

    salvaNuovaVersioneDoc(dataInizioVal) {
        return function (dispatch, getState) {
            let doc = getState().documentiReducer.documento;
            console.log("Creazione nuova versione del documento con id " + doc.id + ". Data inizio validità: " + dataInizioVal);

            return Rest.postForm("admin/armCorePrint/nuovaVersioneDocumento",
                {
                    docSorgenteId: doc.id,
                    dataInizioValidita: dataInizioVal.getTime()
                }, dispatch).then(
                    function (resolve) {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRINT.DOCUMENTI.INSERT_SUCCESS','Nuova versione del documento inserita con successo')));
                        return resolve;
                    },
                    function (reject) {
                        dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRINT.DOCUMENTI.SAVED_ERROR','Errore salvataggio nuova versione documento')));
                        return reject;
                    });
        }
    }

    salvaDoc() {
        return (dispatch, getState) => {

            let document = getState().documentiReducer.nuovoDoc;
            return Rest.post('admin/armCorePrint/saveDocument', document, dispatch).then(
                resolve => {

                    let updateDocument = {
                        nuovoDoc: {
                            $set: document
                        }
                    }

                    dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
                    dispatch(app_actions.addNotify('SUCCESS', i18n('ARM_CORE_PRINT.DOCUMENTI.SAVED_SUCCESS', 'Il documento è salvato con successo')));
                    return resolve;
                }, reject => {
                    dispatch(app_actions.addNotify('DANGER', reject.responseJSON.message));
                    return reject;
                });

        }
    }

    setIsAlreadyExistingDoc(isAlreadyExistingDoc) {
        return function (dispatch, getState) {
            dispatch({
                type: EnumDocumentiActions.IS_ALREADY_EXISTING_DOC,
                result: isAlreadyExistingDoc
            })
        }
    }

    getDocumentById(docId) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/armCorePrint/getDocumentById', { id: docId, getCompleteDocument: true }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumDocumentiActions.HANDLE_CHANGE_DOC, result: resolve });
                    if (resolve) {
                        dispatch({ type: EnumDocumentiActions.LOAD_DOCUMENTO, result: resolve });
                        let listParameters = resolve.listParameters;
                        let parametri = new Map();
                        if (listParameters) {
                            listParameters.forEach(p => {
                                parametri.set(p, null)
                            })

                            let updateDocument = {
                                parametersMap: {
                                    $set: parametri
                                },
                            }

                            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
                        }
                    }
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    setIsInEditMode(isInEditMode) {
        return function (dispatch, getState) {
            dispatch({ type: EnumDocumentiActions.SET_IS_IN_EDIT_MODE, result: isInEditMode })
        }
    }

    changeIsAlreadyExistingDoc(isAlreadyExistingDoc) {
        return function (dispatch, getState) {
            dispatch({
                type: EnumDocumentiActions.IS_ALREADY_EXISTING_DOC,
                result: isAlreadyExistingDoc
            })
        }
    }

    pubblicaDocumento(idDocToPublish) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/armCorePrint/publishDocument', { id: idDocToPublish }, dispatch).then(
                resolve => {
                    if (resolve) {
                        dispatch({ type: EnumDocumentiActions.PUBLISH_DOCUMENT, publishStatus: resolve.pubblicato });
                    }
                    return resolve;
                },
                reject => {
                    return reject;
                }
            );
        }
    }

    eliminaDoc() {
        let that = this;
        return function (dispatch, getState) {
            let nuovoDoc = getState().documentiReducer.nuovoDoc;
            return Rest.postForm('admin/armCorePrint/deleteDocumentById', { id: nuovoDoc.id }, dispatch).then(
                resolve => {
                    dispatch(app_actions.addNotify('SUCCESS', i18n('ARM_CORE_PRINT.DS.SAVED_SUCCESS', 'Il documento è eliminato con successo')));
                    dispatch(that.getDocumenti());
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    resetDoc() {
        return function (dispatch, getState) {
            dispatch({
                type: EnumDocumentiActions.HANDLE_CHANGE_DOC,
                result: {}
            })

            let updateDocument = {
                validationDoc: {
                    $set: new Map()
                }
            }

            dispatch({
                type: EnumDocumentiActions.DOCUMENTI_UPDATE,
                documenti: updateDocument
            })
        }
    }

    salvaDS() {
        return (dispatch, getState) => {

            let dataSource = getState().documentiReducer.dataSource;
            if (dataSource.listParam.length === 1 && dataSource.listParam[0].nome === '' && dataSource.listParam[0].descrizione === '') {
                dataSource.listParam = []
            }
            return Rest.post('admin/armCorePrint/saveDataSource', dataSource, dispatch).then(
                resolve => {
                    let updateDocument = {
                        dataSource: {
                            $set: resolve
                        },
                    }

                    dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
                    dispatch(app_actions.addNotify('SUCCESS', i18n('ARM_CORE_PRINT.DS.SAVED_SUCCESS', 'La datasource è salvata con successo')));
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    getDataSourceLista() {
        return function (dispatch) {
            return Rest.post('admin/armCorePrint/listaDataSource', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumDocumentiActions.DATA_SOURCE_LIST, result: resolve });
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    inizializzaCreazioneDocument() {
        return (dispatch, getState) => {
            return Rest.post('admin/armCorePrint/listaDataSource', null, dispatch).then(
                resolve => {
                    let updateDocument = {
                        nuovoDoc: {
                            listDataSources: {
                                $set: resolve
                            }
                        }
                    }

                    dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
                }, reject => {
                    return reject;
                });

        }
    }

    handleChangeParam(id, value, index) {
        return function (dispatch, getState) {
            let dataSource = getState().documentiReducer.dataSource;
            dataSource = update(dataSource, {
                listParam: {
                    [index]: {
                        [id]: {
                            $set: value
                        }
                    }
                }
            })

            dispatch({
                type: EnumDocumentiActions.HANDLE_CHANGE_DS,
                result: dataSource
            })
        }
    }

    addParametro() {
        return function (dispatch, getState) {
            let dataSource = getState().documentiReducer.dataSource;
            dataSource = update(dataSource, {
                listParam: {
                    $push: [{
                        nome: '',
                        descrizione: ''
                    }]
                }
            })

            dispatch({
                type: EnumDocumentiActions.HANDLE_CHANGE_DS,
                result: dataSource
            })
        }
    }

    deleteParametro(index) {
        return function (dispatch, getState) {
            let dataSource = getState().documentiReducer.dataSource;
            dataSource = update(dataSource, { listParam: { $splice: [[index, 1]] } });
            dispatch({ type: EnumDocumentiActions.HANDLE_CHANGE_DS, result: dataSource })
        }
    }

    getDataSource(idDataSource) {
        let that = this;
        return function (dispatch, getState) {
            return Rest.postForm('admin/armCorePrint/getDataSourceById', { idDataSource: idDataSource }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumDocumentiActions.GET_DS, result: resolve });
                    if (!resolve.categoria) {
                        dispatch(that.setDefaultData());
                    }
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    eliminaDataSource() {
        return function (dispatch, getState) {
            let dataSource = getState().documentiReducer.dataSource;
            return Rest.postForm('admin/armCorePrint/deleteDataSourceById', { idDataSource: dataSource.id }, dispatch).then(
                resolve => {
                    dispatch(app_actions.addNotify('SUCCESS', i18n('ARM_CORE_PRINT.DS.ELIMINATA_SUCCESS', 'La datasource è eliminata con successo')));
                    dispatch(DataSourceActions.getListaDataSource);
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    resetDS() {
        return function (dispatch, getState) {
            let dataSource = {};
            dataSource.listParam = [];
            dispatch({ type: EnumDocumentiActions.HANDLE_CHANGE_DS, result: dataSource })
        }
    }

    toggleModifica(mod) {
        return function (dispatch, getState) {
            dispatch({
                type: EnumDocumentiActions.TOGGLE_MODIFICA,
                result: mod
            })
        }
    }

    scaricaDocument(id) {
        console.log(this.moduleName + "  scaricaDocument [id] " + id);
        let path = "armCorePrint/download/" + id;
        return function (dispatch) {
            return Rest.downloadFileStreamPOST(path, dispatch).then(
                resolve => {
                    console.log(" download [path] " + path) + " resolve";
                }, reject => {
                    console.log(" download [path] " + path) + " reject";
                });
        }
    }

    inizializzaModificaDocument() {
        console.log(this.moduleName + "  inizializzaModificaDocument ");
        return function (dispatch, getState) {
            let document = getState().documentiReducer.nuovoDoc;
            let dataSourcesSelected = document.listDataSources
            return Rest.post('admin/armCorePrint/listaDataSource', null, dispatch).then(
                resolve => {
                    resolve.forEach(element => {
                        element.checked = false;
                        if (dataSourcesSelected) {
                            let indexFound = dataSourcesSelected.findIndex(ds => ds.id === element.id);
                            if (indexFound != -1) {
                                element.checked = true
                            }
                        }
                    });

                    let updateDocument = {
                        nuovoDoc: {
                            listDataSources: {
                                $set: resolve
                            }
                        },
                    }

                    dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    listParamByIdDocument(idDocument) {
        console.log(this.moduleName + "  listParamByIdDocument " + idDocument);
        return function (dispatch, getState) {
            return Rest.postForm('admin/armCorePrint/listParamByIdDocument', { id: idDocument }, dispatch).then(
                resolve => {
                    let updateDocument = {
                        nuovoDoc: {
                            listParameters: {
                                $set: resolve
                            }
                        },
                    }

                    dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });

                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    handleChangeParameter(key, value) {
        return function (dispatch, getState) {

            let parametersMap = getState().documentiReducer.parametersMap;
            parametersMap.set(key, value);
            let updateDocument = {

                parametersMap: {
                    $set: parametersMap
                },
            }

            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });


        }
    }

    stampaPreview() {
        let that = this;
        console.log(this.moduleName + "  stampaPreview ");
        return function (dispatch, getState) {

            let document = getState().documentiReducer.nuovoDoc;
            let parametersMap = getState().documentiReducer.parametersMap;

            let parameterObj = new Object();
            parametersMap.forEach((values, keys) => {
                parameterObj[keys] = values
            })

            let pojo = {
                documentAlias: document.alias,
                parametri: parameterObj
            }

            if (document.engine === "PDF_PRINT") {
                return Rest.post('admin/armCorePrint/printPdf', pojo, dispatch,).then(
                    resolve => {
                        let pojodoc = {
                            documentAlias: document.alias,
                            parametri: { id: resolve }
                        }
                        Rest.newDownloadFileStreamPOST('admin/armCorePrint/docFromPrint', pojodoc, dispatch,).then(
                            resolve => {
                            }, reject => {
                                return reject;
                            }).then(
                                resolve => {
                                    return Rest.postForm('admin/armCorePrint/getDocumentById', { id: document.id, getCompleteDocument: true }, dispatch).then(
                                        resolve => {

                                            let updateDocument = {

                                                nuovoDoc: {
                                                    listHistory: {
                                                        $set: resolve.listHistory
                                                    }
                                                },
                                            }
                                            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });

                                            return resolve;
                                        }
                                    )
                                }
                            );
                    }, reject => {
                        return reject;
                    });
            } else {
                return Rest.post('admin/armCorePrint/print', pojo, dispatch,).then(
                    resolve => {
                        let pojodoc = {
                            documentAlias: document.alias,
                            parametri: { id: resolve }
                        }
                        Rest.newDownloadFileStreamPOST('admin/armCorePrint/docFromPrint', pojodoc, dispatch,).then(
                            resolve => {


                            }, reject => {
                                return reject;
                            }).then(
                                resolve => {
                                    return Rest.postForm('admin/armCorePrint/getDocumentById', { id: document.id, getCompleteDocument: true }, dispatch).then(
                                        resolve => {
                                            let updateDocument = {
                                                nuovoDoc: {
                                                    listHistory: {
                                                        $set: resolve.listHistory
                                                    }
                                                },
                                            }
                                            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
                                            return resolve;
                                        }
                                    )
                                }
                            );

                    }, reject => {
                        return reject;
                    });
            }
        }
    }

    setDefaultData() {
        return function (dispatch, getState) {
            let dataSource = getState().documentiReducer.dataSource;
            dataSource.categoria = '';
            dataSource = update(dataSource, {
                categoria: {
                    $set: "JSON"
                }
            })

            dispatch({
                type: EnumDocumentiActions.HANDLE_CHANGE_DS,
                result: dataSource
            })
        }
    }

    validationDocument(key, value) {
        return function (dispatch, getState) {
            let validationDoc = new Map();
            let nuovoDoc = getState().documentiReducer.nuovoDoc;
            let required = ['alias', 'categoria', 'engine', 'dataInizio'];
            if (nuovoDoc.engine === "ASPOSE") {
                required.push("template");
            }
            if (nuovoDoc.engine === "PDF_PRINT") {
                required.push("template");
            }
            for (let i = 0; i < required.length; i++) {
                if (required[i] === 'content' || required[i] === 'template') {

                    if (nuovoDoc[required[i]] === undefined || nuovoDoc[required[i]] === '' || nuovoDoc[required[i]] === null ||
                        Object.keys(nuovoDoc[required[i]]).length === 0
                    ) {
                        validationDoc.set(required[i], i18n('ARM_CORE_PRINT.SHARED.VALORE_OBBLIGATORIO', 'Campo obbligatorio'));
                    }
                } else {
                    if (nuovoDoc[required[i]] === undefined || nuovoDoc[required[i]] === '' || nuovoDoc[required[i]] === null) {
                        validationDoc.set(required[i], i18n('ARM_CORE_PRINT.SHARED.VALORE_OBBLIGATORIO', 'Campo obbligatorio'));
                    }
                }

                let updateDocument = {

                    validationDoc: {
                        $set: validationDoc
                    },
                }

                dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });

            }

            if (validationDoc.size === 0) {
                return true;
            }
            return false;
        }
    }

    deleteErrore(id) {
        return function (dispatch, getState) {
            let validationDoc = getState().documentiReducer.validationDoc;
            validationDoc.delete(id);

            let updateDocument = {

                validationDoc: {
                    $set: validationDoc
                },
            }

            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
        }
    }

    getPrintStatistiche() {
        return function (dispatch, getState) {

            return Rest.post('admin/armCorePrint/getPrintStatistiche', null, dispatch,).then(
                resolve => {
                    let updateDocument = {

                        statistiche: {
                            $set: resolve
                        },
                    }

                    dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
                    return resolve;
                }, reject => {
                    return reject;
                });

        }
    }

    getHistory(row) {
        return function (dispatch, getState) {

            let map = new Map(Object.entries(row.historyParams));

            let updateDocument = {
                history: {
                    $set: row
                },
                parametersMap: {
                    $set: map
                }
            }

            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });

        }
    }

    deleteHistory(row) {
        let that = this;
        return function (dispatch, getState) {
            return Rest.postForm('admin/armCorePrint/deleteHistoryById', { id: row.id }, dispatch,).then(
                resolve => {
                    dispatch(that.getDocumentById(row.idDocument));
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    handleChangeDSPrevPar(key, value) {
        return function (dispatch, getState) {
            // let dsPreviewParams = getState().documentiReducer.dsPreviewParams;
            // if (dsPreviewParams.length === 0 || dsPreviewParams[index] === undefined) {
            //     dsPreviewParams.push({});
            // }
            // dsPreviewParams = update(dsPreviewParams, {
            //     [index]: {
            //         [id]: {
            //             $set: value
            //         }
            //     }
            // })

            // let updateDocument = {
            //     dsPreviewParams: {
            //         $set: dsPreviewParams
            //     }
            // }

            // dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });

            let dsPreviewParams = getState().documentiReducer.dsPreviewParams;
            dsPreviewParams.set(key, value);
            let updateDocument = {

                dsPreviewParams: {
                    $set: dsPreviewParams
                },
            }

            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
        }
    }

    stampaDsPreview() {
        let that = this;
        console.log(this.moduleName + "  stampaPreview ");
        return function (dispatch, getState) {

            let dataSource = getState().documentiReducer.dataSource;
            let dsPreviewParams = getState().documentiReducer.dsPreviewParams;

            // let mapPreview = new Map(
            //     dsPreviewParams.map(object => {
            //         return [object.nome, object.descrizione];
            //     }),
            // );

            let parameterObj = new Object();
            dsPreviewParams.forEach((values, keys) => {
                parameterObj[keys] = values
            })

            let pojo = {
                documentAlias: dataSource.alias,
                parametri: parameterObj
            }

            return Rest.post('admin/armCorePrint/eseguiDataSource', pojo, dispatch,).then(
                resolve => {
                    let pojodoc = {
                        documentAlias: dataSource.alias,
                        parametri: { id: resolve }
                    }
                    Rest.newDownloadFileStreamPOST('admin/armCorePrint/docFromEseguiDataSource', pojodoc, dispatch,).then(
                        resolve => {
                            return resolve;
                        }, reject => {
                            return reject;
                        });
                }, reject => {
                    return reject;
                });
        }
    }

    resetDocTab() {
        return function (dispatch, getState) {
            let documenti = {
                tabSelected: {
                    $set: 'doc-tab'
                }
            }

            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: documenti });
            return Promise.resolve();
        }
    }

    resetDSTab() {
        return function (dispatch) {

            let documenti = {
                dataSourceTabSel: {
                    $set: 'dataSource-tab'
                }
            }

            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: documenti });
            return Promise.resolve();
        }
    }


    handleChangeUtilities(id, value) {
        return function (dispatch) {
            let documenti = {
                utilities: {
                    [id]: {
                        $set: value
                    }
                }
            }

            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: documenti });
        }
    }


    generaTemplate(idFilePdf, idFileExcel, denominazioneRin) {
        return function (dispatch) {
            return Rest.downloadFileStreamPOST('admin/utilities/generatePdfWithFiledsRenamed', { idFilePdf: idFilePdf, idFileExcel: idFileExcel, denominazione: denominazioneRin }, dispatch,).then(
                resolve => {
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    generaXls(idFilePdf, denominazione) {
        return function (dispatch) {
            return Rest.downloadFileStreamPOST('admin/utilities/generateExcelWithFieldsName', { idFilePdf: idFilePdf, denominazione: denominazione }, dispatch,).then(
                resolve => {
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }


    generaPDF(idFilePdf, denominazione) {
        return function (dispatch) {
            return Rest.downloadFileStreamPOST('admin/utilities/generatePdfWithFieldsName', { idFilePdf: idFilePdf, denominazione: denominazione }, dispatch,).then(
                resolve => {
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    riInzializzaUtilities() {
        return function (dispatch) {
            let documenti = {
                utilities: {
                    $set: {
                        listDocPdf: []
                    }
                }
            }

            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: documenti });
        }
    }

    removeFileUtilities(fileIdx, name) {
        return function (dispatch, getState) {

            // tolgo il documento anche dalla entity

            let updateDocument = {
                utilities: {
                    [name]: {
                        $set: {}
                    }
                },
            }

            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
        }
    }

    toggleMostraPopupConfermaNuovaVersione() {
        return function (dispatch, getState) {
            let newState = !getState().documentiReducer.showConfermaNuovaVersione;
            dispatch({ type: EnumDocumentiActions.TOGGLE_MOSTRA_POPUP_CONFERMA_NUOVA_VERSIONE, showConfermaNuovaVersione: newState });
        }
    }

    setIdDocumentoOrigine(idDocumentoOrigine) {
        return function (dispatch) {
            dispatch({ type: EnumDocumentiActions.ID_DOCUMENTO_ORIGINE, idDocumentoOrigine: idDocumentoOrigine });
        }
    }

    newPdfDocument(value) {
        return function (dispatch, getState) {
            let listDocPdf = getState().documentiReducer.utilities.listDocPdf;

            if (listDocPdf == undefined || listDocPdf == null) {
                listDocPdf = [];
            }
            let indexNext = listDocPdf.length;

            let documenti = {
                utilities: {
                    listDocPdf: {
                        [indexNext]: {
                            $set: {}
                        }
                    }
                }
            }
            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: documenti });
        }
    }

    handleChangeDocPdfUtilities(id, value) {
        return function (dispatch) {
            let documenti = {
                utilities: {
                    listDocPdf: {
                        [id]: {
                            $set: value
                        }
                    }
                }
            }
            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: documenti });
        }
    }

    removeFilePdfUtilities(name, fileIdx) {
        return function (dispatch, getState) {
            let updateDocument = {
                utilities: {
                    listDocPdf: {
                        [fileIdx]: {
                            $set: {}
                        }
                    }
                }
            }
            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
        }
    }

    removeFieldPdfUtilities(index) {
        return function (dispatch, getState) {

            let listDocPdf = getState().documentiReducer.utilities.listDocPdf;
            if (listDocPdf) {
                //let index = listDocPdf.length - 1;
                listDocPdf = update(listDocPdf, { $splice: [[index, 1]] });
            }

            let updateDocument = {
                utilities: {
                    listDocPdf: {
                        $set: listDocPdf
                    }
                }
            }
            dispatch({ type: EnumDocumentiActions.DOCUMENTI_UPDATE, documenti: updateDocument });
        }
    }

    generaMergedPDF(listDoc, denominazione) {
        let obj = {
            listDoc: listDoc,
            denominazione:denominazione
        }
        return function (dispatch) {
            return Rest.newDownloadFileStreamPOST('admin/utilities/generateMergedPdf', obj, dispatch,).then(
                resolve => {
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    exportDocument(id) {
        return function (dispatch) {
            return Rest.downloadFileStreamPOST('admin/armCorePrint/downloadDocument', { idDocumento: id }, dispatch).then(
                resolve => {
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }
};

export default DocumentiActions = new DocumentiActions;
